import React from 'react';
import './App.css';
import 'antd/dist/antd.css'
import Layer from "./ui/Layer";
import {Participants} from "./pages/eisplay/Participants";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Events from "./pages/events/Events";
import Login from "./pages/login/Login";
import {useSelector} from "react-redux";

interface IState {
    authReducer: {
        IsLoggedIn: boolean
    }
}

function App() {
    const isLoggedIn = useSelector((state: IState) => state.authReducer.IsLoggedIn)

    return (
        <Router>
            <Layer>
                {isLoggedIn &&
                    <Routes>
                        <Route path={'/events/:comp/participants'} element={<Participants/>}/>
                        <Route path={'/events'} element={<Events/>}/>
                        <Route path={'/'} element={<Events/>}/>
                    </Routes>
                }
                {!isLoggedIn &&
                    <Login/>
                }
            </Layer>
        </Router>
    );
}

export default App;
